var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step2-container" },
    [
      _c(
        "div",
        {
          staticClass: "main-content-container no-scrollbar",
          on: { scroll: _vm.scrollToEnd }
        },
        [
          _vm.currentOccassionImage
            ? _c(
                "div",
                {
                  staticClass: "storefront-header",
                  style: _vm.storefrontHeaderConfig
                    ? "background-color:" + _vm.storefrontHeaderConfig.color
                    : ""
                },
                [
                  _vm.showCustomHeader
                    ? _c("div", { staticClass: "custom-header" }, [
                        _c("img", {
                          attrs: { src: _vm.storefrontHeaderConfig.image }
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(_vm.storefrontHeaderConfig.text))
                        ])
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-container",
              class: _vm.isSticking ? "sticky" : "",
              attrs: { id: "header-container" }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm.secondOccasions && _vm.secondOccasions.length > 0
                ? _c("div", { staticClass: "filter-categories-container" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "categories-container no-scrollbar" },
                      _vm._l(_vm.secondOccasions.slice(0, 3), function(
                        occasion
                      ) {
                        return _c(
                          "button",
                          {
                            key: occasion.title,
                            staticClass: "step-button",
                            class: _vm.selectedOccasion.includes(occasion.title)
                              ? "selected"
                              : "",
                            on: {
                              click: function($event) {
                                return _vm.setSelectedOccasion(occasion.title)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " \n                        " +
                                _vm._s(occasion.title) +
                                "\n                    "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "happybox-button white border",
                        on: {
                          click: function($event) {
                            return _vm.showFilters()
                          }
                        }
                      },
                      [_vm._v("+ Filters")]
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-container" }, [
            !_vm.notFilter
              ? _c(
                  "ul",
                  { staticClass: "products-container no-scrollbar" },
                  [
                    _vm.nonFilteredProducts.length > 0
                      ? _c("p", { staticClass: "other-gifts" }, [
                          _vm._v(_vm._s(_vm.breadcrumbText))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.sortedProducts, function(addonProduct) {
                      return _c(
                        "li",
                        { key: addonProduct.id },
                        [
                          _c("AddonProductNew", {
                            attrs: {
                              product: addonProduct,
                              cartProducts: _vm.selectedAddonProducts,
                              addCopy: _vm.addCopy
                            },
                            on: {
                              loadmodal: function($event) {
                                return _vm.openModal($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.nonFilteredProducts.length > 0
                      ? _c("p", { staticClass: "other-gifts" }, [
                          _vm._v("All Other Gifts")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.nonFilteredProducts, function(addonProduct) {
                      return _c(
                        "li",
                        { key: addonProduct.id },
                        [
                          _c("AddonProductNew", {
                            attrs: {
                              product: addonProduct,
                              cartProducts: _vm.selectedAddonProducts,
                              addCopy: _vm.addCopy
                            },
                            on: {
                              loadmodal: function($event) {
                                return _vm.openModal($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              : _c(
                  "ul",
                  { staticClass: "products-container no-scrollbar" },
                  [
                    _vm.showReco && _vm.recoProducts.length > 0
                      ? [
                          _c("p", { staticClass: "other-gifts" }, [
                            _vm._v("Recommended")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.recoProducts, function(addonProduct) {
                            return _c(
                              "li",
                              { key: addonProduct.id + "reco" },
                              [
                                _c("AddonProductNew", {
                                  attrs: {
                                    product: addonProduct,
                                    cartProducts: _vm.selectedAddonProducts,
                                    maxCapacity: _vm.maxCapacity,
                                    currentCapacity: _vm.currentCapacity,
                                    boxQty: _vm.boxQty,
                                    productLimit: _vm.productLimit,
                                    addCopy: _vm.addCopy
                                  },
                                  on: {
                                    loadmodal: function($event) {
                                      return _vm.openModal($event)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.occasionProducts, function(set) {
                      return [
                        _c("p", { staticClass: "other-gifts" }, [
                          _vm._v(
                            _vm._s(
                              set.occasion == "Storefront"
                                ? _vm.corpName + " Products"
                                : set.occasion
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(set.products, function(addonProduct) {
                          return _c(
                            "li",
                            { key: addonProduct.id + set.occasion },
                            [
                              addonProduct != "ad"
                                ? _c("AddonProductNew", {
                                    attrs: {
                                      product: addonProduct,
                                      cartProducts: _vm.selectedAddonProducts,
                                      addCopy: _vm.addCopy
                                    },
                                    on: {
                                      loadmodal: function($event) {
                                        return _vm.openModal($event)
                                      }
                                    }
                                  })
                                : _c("div", { staticClass: "promotion" }, [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "https://cdn.shopify.com/s/files/1/1363/8433/files/cross_promotion_packaging_logo.png?v=1721312901",
                                        alt: "promotion"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "floating-container" },
                                      [
                                        _c("p", { staticClass: "title" }, [
                                          _vm._v(
                                            "Want custom packaging or swag?"
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "subtitle" }, [
                                          _vm._v("We do that too. "),
                                          _c("span", [
                                            _vm._v("*minimums apply")
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "happybox-button white border",
                                            attrs: {
                                              target: "_blank",
                                              href: "/pages/corporate-gifts"
                                            }
                                          },
                                          [_vm._v("Learn More")]
                                        )
                                      ]
                                    )
                                  ])
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _vm.showReco &&
                        _vm.recoProducts.length > 0 &&
                        set.occasion.includes(_vm.corpName)
                          ? _c("p", { staticClass: "other-gifts" }, [
                              _vm._v("Recommended")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.recoProducts, function(addonProduct) {
                          return _vm.showReco &&
                            _vm.recoProducts.length > 0 &&
                            set.occasion.includes(_vm.corpName)
                            ? _c(
                                "li",
                                { key: addonProduct.id + "reco" },
                                [
                                  _c("AddonProductNew", {
                                    attrs: {
                                      product: addonProduct,
                                      cartProducts: _vm.selectedAddonProducts,
                                      maxCapacity: _vm.maxCapacity,
                                      currentCapacity: _vm.currentCapacity,
                                      boxQty: _vm.boxQty,
                                      productLimit: _vm.productLimit,
                                      addCopy: _vm.addCopy
                                    },
                                    on: {
                                      loadmodal: function($event) {
                                        return _vm.openModal($event)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        })
                      ]
                    })
                  ],
                  2
                )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.selectedAddonProducts.length > 0
        ? _c("SideCartMobile", {
            attrs: {
              recommendedAddons: _vm.modalRecommendedProducts,
              cartProducts: _vm.selectedAddonProducts
            },
            on: {
              openmodal: function($event) {
                return _vm.openModal($event)
              },
              changepage: function($event) {
                return _vm.changePage($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AddonProductModalMobile", {
        attrs: {
          showModal: _vm.showModal,
          selectedAddon: _vm.currentSelectedAddon,
          addonProducts: _vm.modalProducts,
          cartProducts: _vm.selectedAddonProducts,
          recommendedProducts: _vm.modalRecommendedProducts
        },
        on: {
          closemodal: function($event) {
            return _vm.closeModal()
          },
          changeselectedaddon: function($event) {
            return _vm.openModal($event)
          }
        }
      }),
      _vm._v(" "),
      _vm.showBrandableModal == true && _vm.currentSelectedAddon != null
        ? _c("BrandableProductModal", {
            attrs: {
              selectedAddon: _vm.currentSelectedAddon,
              addonProducts: _vm.modalProducts,
              cartProducts: _vm.selectedAddonProducts,
              recommendedProducts: _vm.modalRecommendedProducts
            },
            on: {
              closemodal: function($event) {
                return _vm.closeModal()
              },
              changeselectedaddon: function($event) {
                return _vm.openModal($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filterIsShown
        ? _c("FiltersMobile", {
            attrs: {
              filteredPreAddons: _vm.filteredPreProducts,
              filteredAddons: _vm.sortedProducts
            },
            on: {
              goall: _vm.goAll,
              closefilter: function($event) {
                return _vm.showFilters()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sticky-image-container" }, [
      _c("p", { staticClass: "steps" }, [
        _vm._v("\n                    STEP 1: Add gifts!\n                ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"
        }
      }),
      _vm._v("\n                    Filter by:\n                ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }